<div style="height: 94vh; background-color: aliceblue;">
  <div style="width: 100%; height: 100%;">
    <!-- CREATE MODE -->
    <div *ngIf="isCreateMode; else editModeBlock">
      <h1>Создать сущность</h1>

      <mat-horizontal-stepper #stepper>
        <mat-step [stepControl]="firstFormGroup" label="Выбор шаблона">
          <form [formGroup]="firstFormGroup">
            <p>Выберите базовый шаблон для новой сущности</p>
            
            <div class="template-selection-container">
              <div class="template-table-section">
                <table mat-table [dataSource]="DataSourceTable" class="mat-elevation-z8" style="width:100%">
                  <ng-container matColumnDef="ID">
                    <th mat-header-cell *matHeaderCellDef>ID</th>
                    <td mat-cell *matCellDef="let row">{{ row.ID }}</td>
                  </ng-container>
                  <ng-container matColumnDef="ShortTitle">
                    <th mat-header-cell *matHeaderCellDef>Наименование</th>
                    <td mat-cell *matCellDef="let row">{{ row.ShortTitle }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Description">
                    <th mat-header-cell *matHeaderCellDef>Описание</th>
                    <td mat-cell *matCellDef="let row">{{ row.Description }}</td>
                  </ng-container>
                  <ng-container matColumnDef="ArchiveSign">
                    <th mat-header-cell *matHeaderCellDef>Архив</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-icon *ngIf="row.ArchiveSign" color="warn">archive</mat-icon>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="SecurityLevel">
                    <th mat-header-cell *matHeaderCellDef>Доступ</th>
                    <td mat-cell *matCellDef="let row">{{ row.SecurityLevel }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                      (click)="getrow(row)"
                      (dblclick)="stepper.next()"
                      [class.selected]="row.ID === selected_template.ID"
                      style="cursor:pointer"></tr>
                </table>
              </div>
              
              <!-- Предварительный просмотр выбранного шаблона -->
              <div class="template-preview-section" *ngIf="selected_template.ID">
                <h3>Предварительный просмотр шаблона: {{ selected_template.ShortTitle }}</h3>

                <!-- Описание шаблона -->
                <div class="template-description-preview">
                  <h4>Описание</h4>
                  <p *ngIf="selected_template.Description">{{ selected_template.Description }}</p>
                  <p *ngIf="!selected_template.Description">Описание отсутствует</p>
                </div>

                <div class="preview-content">
                  <!-- Изображение шаблона -->
                  <div class="template-image-preview">
                    <h4>Изображение шаблона</h4>
                    <div class="template-image-container">
                      <img *ngIf="img_path" [src]="img_path" alt="Изображение шаблона" class="template-preview-image">
                      <div *ngIf="!img_path" class="no-image-placeholder">
                        <mat-icon>image</mat-icon>
                        <p>Изображение отсутствует</p>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Файлы шаблона -->
                  <div class="template-files-preview">
                    <h4>Файлы шаблона</h4>
                    <div class="template-files-container">
                      <table mat-table [dataSource]="dataSourceFiles" class="template-files-table" *ngIf="files.length > 0">
                        <ng-container matColumnDef="ShortTitle">
                          <th mat-header-cell *matHeaderCellDef>Имя файла</th>
                          <td mat-cell *matCellDef="let file">
                            <mat-icon color="accent">insert_drive_file</mat-icon>
                            {{ file.ShortTitle }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="Actions">
                          <th mat-header-cell *matHeaderCellDef>Действия</th>
                          <td mat-cell *matCellDef="let file">
                            <button mat-icon-button color="primary" (click)="downloadFile(file.ID, file.ShortTitle, file.URL)" matTooltip="Скачать">
                              <mat-icon>cloud_download</mat-icon>
                            </button>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedFileColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedFileColumns;"></tr>
                      </table>
                      <div *ngIf="files.length === 0" class="no-files">
                        <mat-icon>folder_open</mat-icon>
                        <p>Файлы отсутствуют</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div>
            <button mat-raised-button color="primary" matStepperNext [disabled]="!selected_template.ID">Далее</button>
          </div>
        </mat-step>

        <mat-step [stepControl]="secondFormGroup" label="Заполнение">
          <form [formGroup]="secondFormGroup">
            <mat-form-field appearance="fill" class="full-width-field">
              <mat-label>Базовый шаблон</mat-label>
              <input matInput [value]="selected_template.ShortTitle" readonly>
            </mat-form-field>

            <div class="row">
              <div class="col-10">
                <form [formGroup]="form">
                  <formly-form [model]="model_header" [fields]="fields" [options]="options" [form]="form"></formly-form>
                </form>
              </div>
              <div class="col-2">
                <div class="main-image-container" (click)="show_full()">
                  <img id="preview" [src]="img_path" alt="Главное изображение">
                  <div class="overlay-buttons">
                    <button mat-mini-fab color="primary" class="edit-image-btn" (click)="mainImageInput.click(); $event.stopPropagation()">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-mini-fab color="warn" class="delete-image-btn" (click)="removeMainImage(); $event.stopPropagation()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
                <input type="file" #mainImageInput style="display: none;" accept="image/*" (change)="onMainImageSelected($event)">
              </div>
            </div>

            <div *ngIf="selected_template && fields && fields_body">
              <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab label="Знания">
                  <form [formGroup]="form_body">
                    <formly-form [model]="model_body" [fields]="fields_body" [options]="options_body" [form]="form_body"></formly-form>
                  </form>
                </mat-tab>
                <mat-tab label="Управление файлами">
                  <div class="file-management-section">
                    <h2>Управление файлами</h2>
                    <div class="upload-section">
                      <button mat-raised-button color="primary" (click)="fileInput.click()">
                        <mat-icon>attach_file</mat-icon>
                        Выберите файл
                      </button>
                      <span *ngIf="selectedFileName">{{ selectedFileName }}</span>
                      <mat-form-field class="upload-field" appearance="fill">
                        <mat-label>Отображаемое имя</mat-label>
                        <input matInput [(ngModel)]="shortTitle" placeholder="Введите имя файла" name="shortTitle" [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <button mat-raised-button color="primary" (click)="uploadFile()" [disabled]="!selectedFile">
                        <mat-icon>cloud_upload</mat-icon>
                        Загрузить
                      </button>
                      <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" />
                    </div>
                    <table mat-table [dataSource]="dataSourceFiles" class="mat-elevation-z8">
                      <ng-container matColumnDef="ShortTitle">
                        <th mat-header-cell *matHeaderCellDef>Имя файла</th>
                        <td mat-cell *matCellDef="let file">
                          <mat-icon color="accent">insert_drive_file</mat-icon>
                          {{ file.ShortTitle }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="Actions">
                        <th mat-header-cell *matHeaderCellDef>Действия</th>
                        <td mat-cell *matCellDef="let file">
                          <button mat-icon-button color="primary" (click)="downloadFile(file.ID, file.ShortTitle, file.URL)" matTooltip="Скачать">
                            <mat-icon>cloud_download</mat-icon>
                          </button>
                          <button mat-icon-button color="warn" (click)="deleteFile(file.ID)" matTooltip="Удалить">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedFileColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedFileColumns;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
                    <div *ngIf="files.length === 0" class="no-files">
                      <p>Файлы отсутствуют.</p>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div class="action-buttons">
              <button mat-raised-button color="primary" (click)="save()">Создать</button>
              <button mat-raised-button color="warn" (click)="exit()" style="margin-left: 10px;">Отмена</button>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>
    </div>

    <!-- EDIT/PREVIEW MODE -->
    <ng-template #editModeBlock>
      <h1>Редактировать сущность</h1>

      <mat-form-field appearance="fill" class="full-width-field">
        <mat-label>Базовый шаблон</mat-label>
        <input matInput [value]="selected_template.ShortTitle" readonly>
      </mat-form-field>

      <!-- Бейдж: Режим только просмотр -->
      <div *ngIf="isReadOnly" style="color: darkred; font-weight: 700; margin-bottom: 8px;">
        Просмотр (только чтение)
      </div>

      <div class="row">
        <div class="col-10">
          <form [formGroup]="form" [class.readonly]="isReadOnly">
            <formly-form [model]="model_header" [fields]="fields" [options]="options" [form]="form"></formly-form>
          </form>
        </div>

        <div class="col-2">
          <div class="main-image-container" (click)="show_full()" *ngIf="!isReadOnly">
            <img id="preview" [src]="img_path" alt="Главное изображение">
            <div class="overlay-buttons">
              <button *ngIf="!isReadOnly" mat-mini-fab color="primary" class="edit-image-btn" (click)="mainImageInput.click(); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="!isReadOnly" mat-mini-fab color="warn" class="delete-image-btn" (click)="removeMainImage(); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          
          <!-- Изображение в режиме readonly/предпросмотра -->
          <div class="main-image-container" *ngIf="isReadOnly && !isTemplatePreview">
            <div class="readonly-image-placeholder">
              <mat-icon>image</mat-icon>
              <span>Изображение недоступно в режиме предпросмотра</span>
            </div>
          </div>
          
          <!-- Изображение в режиме предпросмотра шаблона -->
          <div class="main-image-container" *ngIf="isReadOnly && isTemplatePreview" (click)="show_full()">
            <img *ngIf="img_path" [src]="img_path" alt="Изображение шаблона">
            <div *ngIf="!img_path" class="readonly-image-placeholder">
              <mat-icon>image</mat-icon>
              <span>Изображение отсутствует</span>
            </div>
          </div>
          <input type="file" #mainImageInput style="display: none;" accept="image/*" (change)="onMainImageSelected($event)">
        </div>
      </div>

      <div *ngIf="selected_template && fields && fields_body">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="Знания">
            <form [formGroup]="form_body" [class.readonly]="isReadOnly">
              <formly-form [model]="model_body" [fields]="fields_body" [options]="options_body" [form]="form_body"></formly-form>
            </form>
          </mat-tab>

          <mat-tab label="Управление файлами">
            <div class="file-management-section">
              <h2 *ngIf="!isReadOnly">Управление файлами</h2>
              <h2 *ngIf="isReadOnly">Файлы</h2>

              <!-- Загрузка файлов только если не readonly -->
              <div class="upload-section" *ngIf="!isReadOnly">
                <button mat-raised-button color="primary" (click)="fileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                  Выберите файл
                </button>
                <span *ngIf="selectedFileName">{{ selectedFileName }}</span>
                <mat-form-field class="upload-field" appearance="fill">
                  <mat-label>Отображаемое имя</mat-label>
                  <input matInput [(ngModel)]="shortTitle" placeholder="Введите имя файла" name="shortTitle" [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="uploadFile()" [disabled]="!selectedFile">
                  <mat-icon>cloud_upload</mat-icon>
                  Загрузить
                </button>
                <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" />
              </div>

              <table mat-table [dataSource]="dataSourceFiles" class="mat-elevation-z8" *ngIf="!isReadOnly || (isReadOnly && isTemplatePreview)">
                <ng-container matColumnDef="ShortTitle">
                  <th mat-header-cell *matHeaderCellDef>Имя файла</th>
                  <td mat-cell *matCellDef="let file">
                    <mat-icon color="accent">insert_drive_file</mat-icon>
                    {{ file.ShortTitle }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th mat-header-cell *matHeaderCellDef>Действия</th>
                  <td mat-cell *matCellDef="let file">
                    <button mat-icon-button color="primary" (click)="downloadFile(file.ID, file.ShortTitle, file.URL)" matTooltip="Скачать">
                      <mat-icon>cloud_download</mat-icon>
                    </button>
                    <button *ngIf="!isReadOnly" mat-icon-button color="warn" (click)="deleteFile(file.ID)" matTooltip="Удалить">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedFileColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedFileColumns;"></tr>
              </table>
              <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons *ngIf="!isReadOnly || (isReadOnly && isTemplatePreview)"></mat-paginator>
              <div *ngIf="files.length === 0" class="no-files">
                <p *ngIf="!isReadOnly">Файлы отсутствуют.</p>
                <p *ngIf="isReadOnly && !isTemplatePreview">В режиме предпросмотра управление файлами недоступно</p>
                <p *ngIf="isReadOnly && isTemplatePreview">Файлы шаблона отсутствуют</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="save()" *ngIf="!isReadOnly">Сохранить</button>
        <button mat-raised-button color="warn" (click)="exit()" style="margin-left: 10px;">Отмена</button>
      </div>
    </ng-template>
  </div>
</div>
